import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { obtenerClientes } from '../../servicios/api';
import ModalEditarDatosCliente from './ModalEditarDatosCliente';

const ClientCard = ({ cliente, onEdit }) => {
    const navigate = useNavigate();

    const handleViewClick = () => {
        navigate(`/clientes/buscar?termino=${encodeURIComponent(cliente.telefono || cliente.nif || '')}`);
    };

    return (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-5 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div className="flex-grow">
                <h3 className="text-lg font-bold text-black mb-2">{cliente.nombre_cliente}</h3>
                <p className="text-sm text-gray-600"><strong>Email:</strong> {cliente.correo_electronico || 'N/A'}</p>
                <p className="text-sm text-gray-600"><strong>Teléfono:</strong> {cliente.telefono || 'N/A'}</p>
                <p className="text-sm text-gray-600"><strong>Dirección:</strong> {cliente.direccion || 'N/A'}</p>
                <p className="text-sm text-gray-600"><strong>NIF/NIE:</strong> {cliente.nif || 'N/A'}</p>
            </div>
            <div className="flex gap-2 self-end md:self-center flex-shrink-0">
                <button onClick={() => onEdit(cliente)} className="bg-[#ee6e3b] text-white px-4 py-2 rounded text-sm font-semibold hover:bg-[#d96233]">Editar</button>
                <button onClick={handleViewClick} className="bg-black text-white px-4 py-2 rounded text-sm font-semibold hover:bg-gray-800">Ver</button>
            </div>
        </div>
    );
};

const BuscarCliente = ({ onVolver }) => {
    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [resultados, setResultados] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [busquedaRealizada, setBusquedaRealizada] = useState(false);
    const [clienteEnEdicion, setClienteEnEdicion] = useState(null);

    const handleClienteGuardado = (clienteActualizado) => {
        setResultados((actuales) => actuales.map((cliente) => (
            cliente.id_cliente === clienteActualizado.id_cliente ? clienteActualizado : cliente
        )));
    };

    const handleSearch = async () => {
        if (!terminoBusqueda.trim()) {
            setError('Por favor, introduce un término de búsqueda.');
            return;
        }
        
        setIsLoading(true);
        setError(null);
        setBusquedaRealizada(true);

        try {
            const respuesta = await obtenerClientes(terminoBusqueda);
            if (respuesta.exito) {
                setResultados(respuesta.clientes);
            } else {
                setError(respuesta.mensaje);
                setResultados([]);
            }
        } catch (err) {
            setError('No se pudo conectar con el servidor.');
            setResultados([]);
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section>
            <div className="flex justify-between items-center mb-8 pb-4 border-b-2 border-[#ee6e3b]">
                <h2 className="text-3xl font-bold text-black">Buscar Cliente</h2>
                {onVolver && (
                    <button onClick={onVolver} className="bg-black text-white px-5 py-2.5 rounded-md text-sm font-semibold hover:bg-gray-800 transition-colors">
                        &larr; Volver
                    </button>
                )}
            </div>

            <div className="mb-8">
                <div className="flex flex-col md:flex-row gap-4 mb-4">
                    <input 
                        type="text"
                        value={terminoBusqueda}
                        onChange={(e) => setTerminoBusqueda(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                        placeholder="Buscar por nombre, NIF, email, teléfono, ubicación..."
                        className="flex-grow p-3 border-2 border-gray-300 rounded-md focus:outline-none focus:border-[#ee6e3b] text-base"
                    />
                    <button 
                        onClick={handleSearch}
                        className="bg-[#ee6e3b] text-white px-6 py-3 rounded-md font-semibold hover:bg-[#d96233] transition-colors disabled:opacity-50"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Buscando...' : 'Buscar'}
                    </button>
                </div>
            </div>

            <div className="space-y-4">
                {error && <p className="text-red-500 text-center">{error}</p>}
                {!isLoading && busquedaRealizada && resultados.length === 0 && (
                    <p className="text-center text-gray-500">No se encontraron clientes con ese criterio de búsqueda.</p>
                )}
                {!isLoading && !busquedaRealizada && (
                     <p className="text-center text-gray-500">Introduce un término de búsqueda para encontrar un cliente.</p>
                )}
                {resultados.map((cliente) => (
                    <ClientCard key={cliente.id_cliente} cliente={cliente} onEdit={setClienteEnEdicion} />
                ))}
            </div>
            <ModalEditarDatosCliente
                isOpen={Boolean(clienteEnEdicion)}
                cliente={clienteEnEdicion}
                onClose={() => setClienteEnEdicion(null)}
                onSaved={handleClienteGuardado}
            />
        </section>
    );
};

export default BuscarCliente;